import { render, staticRenderFns } from "./RegistrationBeforeOrderModal.vue?vue&type=template&id=6b510695&"
import script from "./RegistrationBeforeOrderModal.vue?vue&type=script&lang=js&"
export * from "./RegistrationBeforeOrderModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports